
export default {
  components: {
  },
  props: {
    otherInfo: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
    };
  },
  computed: {
  },
  created() {
  },
  methods: {
  }
};
